import { PLAYER_REGISTRATION_STORAGE_KEY } from '@/constants/playerStorageKeys'

/**
 * Synchronous read of pairing `secret` from web localStorage so the idle UI can show the QR phase
 * on first paint instead of flashing "waiting" until `getRegistration()` resolves.
 */
export function peekWebPairingRegistrationCodeFromLocalStorage(): string | null {
  if (typeof window === 'undefined') { return null }
  try {
    const raw = window.localStorage?.getItem(PLAYER_REGISTRATION_STORAGE_KEY)
    if (raw == null || raw === '') { return null }
    const j = JSON.parse(raw) as { tenantId?: string | null, secret?: unknown }
    if (j.tenantId != null && j.tenantId !== '') { return null }
    if (typeof j.secret === 'string' && j.secret !== '') { return j.secret }
  }
  catch {
    // ignore invalid JSON
  }
  return null
}
